import { render } from "./SettingVarious.vue?vue&type=template&id=179f6658&scoped=true&ts=true"
import script from "./SettingVarious.vue?vue&type=script&lang=ts"
export * from "./SettingVarious.vue?vue&type=script&lang=ts"

import "./SettingVarious.vue?vue&type=style&index=0&id=179f6658&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179f6658"]])

export default __exports__